// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"139470de","170":"fbd13b6e","350":"772add35","436":"2b534e0e","453":"3584bd27","483":"3db866c0","614":"d8665bf3","870":"be012857"}[chunkId] + ".chunk.js";
};